import { createGlobalStyle } from 'styled-components';
import { BACKGROUND_COLOR } from './variables';
import { FONTFACE_CIRCULAR } from './fonts';

export const FONT_SIZE = 15;

export const GlobalStyle = createGlobalStyle`

  // ========================
  //  == IMPORT FONTS HERE ==
  // ========================
  ${/*FONTFACE_CIRCULAR*/ ''}

  // ==========================
  // == RULES FOR EVERYTHING ==
  // ==========================

  *,
  *:before,
  *:after {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-smoothing: antialiased;
    box-sizing: border-box;
  }

  html {}

  body {
      background-color: ${BACKGROUND_COLOR};
      font-family: 'Circular', Times New Roman;
      margin: 0;
      text-rendering: geometricPrecision;
      height:100vh;
      overflow-x:hidden;
      font-size: ${FONT_SIZE}px
      line-height: 25px

      @media screen and (max-height: 700px) {
        height:120vh;
      }

      #app{
        min-height:100%;
        // We need to display as flex in order to grow elements
        // which we want to be larger than their content dictates
        // and which we do not want to position absolutely.
        display: flex;
        flex-direction: column;
      }
  }
`;
